import React from "react";
import TrebbleButton from "../common/TrebbleButton";

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, actionLabel, onAction }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 64,
      color: "var(--text-muted)",
    }}
  >
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: 16, opacity: 0.5 }}
    >
      <rect x="6" y="10" width="36" height="28" rx="0" stroke="#ccc" strokeWidth="2" />
      <path d="M6 18h36" stroke="#ccc" strokeWidth="2" />
      <circle cx="14" cy="14" r="2" fill="#ccc" />
      <circle cx="20" cy="14" r="2" fill="#ccc" />
    </svg>
    <p style={{ margin: 0, fontSize: "var(--text-base)", fontWeight: 400 }}>{message}</p>
    {actionLabel && onAction && (
      <TrebbleButton type="primary" onClick={onAction} style={{ marginTop: 20 }}>
        {actionLabel}
      </TrebbleButton>
    )}
  </div>
);

export default EmptyState;
